// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__ftkSH","alert":"SettungsInbox_alert__2FJ9H"};